"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var PrimaryColumn_1 = __importDefault(require("./PrimaryColumn"));
var SecondaryColumn_1 = __importDefault(require("./SecondaryColumn"));
var BasicLayout_1 = __importDefault(require("../basic/BasicLayout"));
var ChildrenUtils_1 = require("../../../common/ChildrenUtils");
var PrimaryColumnType = (react_1.default.createElement(PrimaryColumn_1.default, null)).type;
var SecondaryColumnType = (react_1.default.createElement(SecondaryColumn_1.default, null)).type;
var TwoColumnLayout = function (props) {
    var children = props.children, classes = props.classes, clear = props.clear, reverseHorizontally = props.reverseHorizontally, reverseVertically = props.reverseVertically, width = props.width, otherProps = __rest(props, ["children", "classes", "clear", "reverseHorizontally", "reverseVertically", "width"]);
    var primaryColumn = ChildrenUtils_1.filterChildrenIn(children, PrimaryColumnType);
    var secondaryColumn = ChildrenUtils_1.filterChildrenIn(children, SecondaryColumnType);
    if (primaryColumn.length === 0 || secondaryColumn.length === 0) {
        throw new Error('Both primary and secondary columns are required with the two-column layout.');
    }
    return (react_1.default.createElement(BasicLayout_1.default, __assign({ classes: getClassNames(classes, reverseHorizontally, reverseVertically), clear: clear, width: width }, otherProps),
        react_1.default.createElement("div", { className: "fds-grid" },
            primaryColumn,
            secondaryColumn)));
};
var getClassNames = function (classes, reverseHorizontally, reverseVertically) {
    return classnames_1.default('fds-layout-two-column', {
        'reverse-horizontally': reverseHorizontally,
        'reverse-vertically': reverseVertically
    }, classes);
};
exports.default = TwoColumnLayout;
